export default "__VITE_ASSET__4i4klg5R__"